<template>
  <div class="container-xxl">        
        <div>
            <div style="padding:20px 50px 0px 50px;"></div>
            <Createdtype ref="con1" v-if="typeControlPermission"  />
            <div v-else>
              <span v-text="'您沒有該活動類型管理權限'"></span>
            </div>            
        </div>
  </div>
  
</template>
<script>
import * as moment from "moment/moment";
import Createdtype from "./Createdtype.vue" 
import { mapState } from "vuex"; 
 


export default {
  name: 'Type_control', 
  components: {
    Createdtype
  },     
  data() {
    return {
      data: [],
      actives:{page1:false,page2:true,page3:false}
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["defaultval"]),
      typeControlPermission() {
        const currentVal = this.$route.name;
        // ���o acts_permissions �}�C�A�q defaultval.permissions.acts_permissions
        const acts_permissions = this.defaultval?.permissions?.acts_permissions || [];
        // ��� vals �� Advancementoption ���D�\��
        const adv = acts_permissions.find(item => item.vals === "Advancementoption");
        if (!adv) return null;
        // �b�� acts_detailpermission �̧� vals �� Type_control ���Ӷ�
        return adv.acts_detailpermission.find(d => d.vals === currentVal) || null;
      }    
  },
  mounted() {
    //this.fetch({results:4,page:1,pageSize: 4,pid:this.user.data.user.id });
  },
  methods: {

    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },
  
  },
};
</script>